import WorkOrdersCheckbox from "./WorkOrdersCheckbox";
import WorkOrderStatusChip from "./WorkOrderStatusChip";

const sortable = true;
export const items = [
  {
    id: "workOrder",
    label: "WO #",
    sortable,
  },
  {
    id: "part",
    label: "Part",
  },
  {
    id: "stationId",
    label: "Station",
  },
  {
    id: "departmentId",
    label: "Department",
  },
  {
    id: "startDate",
    label: "Start Date",
    sortable,
  },
  {
    id: "creationDate",
    label: "Created At",
    sortable,
  },
  {
    id: "status",
    label: "Status",
    sortable,
  },
];

export const keys = [
  {
    value: "isChecked",
    variant: "small",
    CustomComponent: WorkOrdersCheckbox,
  },
  {
    value: "workOrder",
    variant: "blueBold",
    navigate: true,
    route: "works",
    id: "workOrder",
  },
  {
    variant: "blueBold",
    value: "partName",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  {
    value: "station",
  },
  {
    value: "department",
  },
  {
    value: "startDate",
    isDate: true,
  },
  {
    value: "creationDate",
    isDate: true,
  },
  {
    value: "status",
    CustomComponent: ({ item }) => (
      <WorkOrderStatusChip status={item?.status} />
    ),
  },
];
